import React from "react";
import { Link } from "react-router-dom";
import { forSaleListings } from "../../mock";
import PropertyCard from "./PropertyCard";
import SwipeRow from "./SwipeRow";
import { ArrowRight } from "lucide-react";

const FeaturedListings = () => (
  <section id="for-sale" className="bg-[#f3f1ec] py-24 md:py-32">
    <div className="max-w-[1700px] mx-auto px-6 md:px-10">
      <div className="flex items-end justify-between mb-12 reveal">
        <div>
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-3">Now on the Market</p>
          <h2 className="font-serif-display text-4xl md:text-5xl font-light text-[#1a1a1a]">{forSaleListings.length} Active Listings</h2>
        </div>
        <Link to="/buy" data-testid="view-all-listings" className="hidden md:flex items-center gap-2 text-[11px] tracking-luxe uppercase text-[#1a1a1a] hover:text-[#b4936a] transition-colors border-b border-[#1a1a1a] hover:border-[#b4936a] pb-1">
          View All Listings <ArrowRight size={14} />
        </Link>
      </div>
      <div className="reveal">
        <SwipeRow testid="featured-listings-swipe">
          {forSaleListings.slice(0, 8).map((item) => (
            <PropertyCard key={item.id} item={item} />
          ))}
        </SwipeRow>
      </div>
      <div className="mt-12 text-center md:hidden">
        <Link to="/buy" className="inline-flex items-center gap-2 text-[11px] tracking-luxe uppercase text-[#1a1a1a] border-b border-[#1a1a1a] pb-1">
          View All {forSaleListings.length} Listings <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  </section>
);

export default FeaturedListings;
